import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/styles';
import {
  Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    TextField
} from "@material-ui/core";
import { SIREN_CONFIG  } from "config.js";
import { withRouter } from "react-router-dom";
import Checkbox from '@mui/material/Checkbox';
import {useSelector} from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";



/**
 * 기상 감지 영역
 * @param {*} props 
 * @returns 
 */
const WakeUpSubRegion = props => {
    const { className, deviceId, ...rest} = props;
    const classes = useStyles();
    const {formatMessage} = useIntl();

    const [subRegions, setSubRegions] = useState([]);
    const [lastRowId, setLastRowId] = useState(0);
    const facility_id = useSelector((store) => store.user.facility_id);


    async function loadWakeUpSubRegions() {

      var url = `${SIREN_CONFIG.HOSTNAME}/device/getWakeUpRegions?facility_id=${facility_id}&deviceId=${deviceId}`;
      const opt = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };

      let regionList = [];
      let response = await fetch(url, opt);
      let responseData = await response.json();

      let rowid = 1;
      responseData.resultData.map(function (row) {
        regionList.push({
          id: rowid++,
          _id: row['_id'],
          rowChecked: false,
          subRegionLabel: row['subRegionLabel'],
          yMin: row['yMin'],
          yMax: row['yMax'],
          xMin: row['xMin'],
          xMax: row['xMax'],
          wakeupDetection: row['wakeupDetection']
        });

        setLastRowId(rowid);
      });

      setSubRegions(regionList);
    }


    const handleInputChange = (e, index) => {
      const {name, value} = e.target;

      const list = [...subRegions];
      list[index][name] = value;
      setSubRegions(list);
    }


    const checkBoxRowClick = (e, index) => {
      const list = [...subRegions];
      list[index]['rowChecked'] = e.target.checked;
      setSubRegions(list);
    }


    const wakeupCheckClick = (e, index) => {
      const {name, checked} = e.target;

      const list = [...subRegions];
      list[index][name] = checked ? 1 : 0;
      setSubRegions(list);
    }


    const handleAddRow = () => {
      const list = [...subRegions];

      list.push({
        id: lastRowId,
        _id: '',
        rowChecked: false,
        subRegionLabel: '',
        yMin: '',
        yMax: '',
        xMin: '',
        xMax: '',
        wakeupDetection: 1,
      });

      setSubRegions(list);
      setLastRowId(lastRowId+1);
    }


    const handleRemoveBtn = () => {
      const list = [...subRegions];

      const delete_ids = [];

      for (var i=0; i<list.length; i++){
        if (list[i].rowChecked == true){
          if (list[i]._id != '' ){
            delete_ids.push(list[i]._id);
          }

          list.splice(i, 1);
          i--;
        }
      }

      setSubRegions(list);

      if (delete_ids.length > 0){
        fetch(`${SIREN_CONFIG.HOSTNAME}/device/deleteWakeUpRegions`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            delete_ids: delete_ids,
          }),
        })
        .then((response) => {
          return response.json();
        })
        .then((responseData) => {
          if (responseData.resultCode === "000") {
            //alert를 표시하지 않음
          } else {
            //에러
            console.log(responseData.message);
            alert(`${formatMessage({id:'update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
          }
        })
        .catch((error) => {
          console.error(error);
          alert(`${formatMessage({id:'update_failed'})}\n${responseData.message}`);
        });
      }

    };



    const handleSaveBtn = () => {

      if (subRegions.length == 0) {return;}

      for (var i=0; i<subRegions.length; i++){
        // console.log("subRegion: " + JSON.stringify(subRegions[i]) );
        let subRegion = subRegions[i];
        if (
          subRegion.xMin.length == 0 ||
          subRegion.xMax.length == 0 ||
          subRegion.yMin.length == 0 ||
          subRegion.yMax.length == 0 ||

          isNaN(Number(subRegion.xMin)) ||
          isNaN(Number(subRegion.xMax)) ||
          isNaN(Number(subRegion.yMin)) ||
          isNaN(Number(subRegion.yMax)) ) {

            alert(formatMessage({id:'region_value_invalid'}));
            return;
          }
      }


      fetch(`${SIREN_CONFIG.HOSTNAME}/device/updateWakeUpRegions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          facility_id: facility_id,
          deviceId: deviceId,
          subRegions: subRegions
        }),
      })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        if (responseData.resultCode === "000") {
          // alert("영역 저장에 성공했습니다.");
          alert(formatMessage({id:'update_successful'}));

          setTimeout(() => {
            /** refresh */
            loadWakeUpSubRegions();
          }, 100);

        } else {
          //에러
          console.log(responseData.message);
          // alert(`영역 저장에 실패했습니다.\n${responseData.message}`);
          alert(`${formatMessage({id:'update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
        }
      })
      .catch((error) => {
        console.error(error);
        // alert("영역 저장에 실패했습니다.");
        alert(`${formatMessage({id:'update_failed'})}\n${responseData.message}`);
      });

    }


    useEffect(() => {
      loadWakeUpSubRegions();
    }, []);

    return (

      <div style={{
        minHeight:240,
        width:'100%',
        marginLeft:"80px",
        marginRight:"80px",
        marginBottom:"20px"
        // alignContent:'center',
        // alignItems:'center',
        // alignSelf:'center'
        }}>

        <Table>
        <TableHead>
          <TableRow>
            <TableCell width='5%' align="center" ></TableCell>
            <TableCell width='15%' align="center"><FormattedMessage id="device_subarea_label" /></TableCell>
            <TableCell width='15%' align="center" >yMin</TableCell>
            <TableCell width='15%' align="center" >yMax</TableCell>
            <TableCell width='15%' align="center" >xMin</TableCell>
            <TableCell width='15%' align="center" >xMax</TableCell>
            <TableCell width='10%' align="center" ><FormattedMessage id="wakeup" /></TableCell>
            {/*
            <TableCell width='10%' align="center" ><FormattedMessage id="fall" /></TableCell> */}
          </TableRow>
        </TableHead>

        <TableBody>
          {subRegions.map( (row, i) => (
            <TableRow
            className={classes.tableRow}
            key={row._id}
            >
              <TableCell width='5%' align="center" >
                <Checkbox
                defaultChecked={false}
                color="primary"
                onClick={ event => checkBoxRowClick(event, i) }
                checked={row.rowChecked}
                />
              </TableCell>

              <TableCell>
                <TextField
                  margin="dense"
                  variant="outlined"
                  value={row.subRegionLabel}
                  name="subRegionLabel"
                  onChange={(e) => handleInputChange(e, i)}
                  />
              </TableCell>
              <TableCell>
                <TextField
                  margin="dense"
                  variant="outlined"
                  value={row.yMin}
                  name="yMin"
                  onChange={(e) => handleInputChange(e, i)}
                  />
              </TableCell>
              <TableCell>
                <TextField
                  margin="dense"
                  variant="outlined"
                  value={row.yMax}
                  name="yMax"
                  onChange={(e) => handleInputChange(e, i)}
                  />
              </TableCell>
              <TableCell>
                <TextField
                  margin="dense"
                  variant="outlined"
                  value={row.xMin}
                  name="xMin"
                  onChange={(e) => handleInputChange(e, i)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  margin="dense"
                  variant="outlined"
                  value={row.xMax}
                  name="xMax"
                  onChange={(e) => handleInputChange(e, i)}
                />
              </TableCell>
              <TableCell align="center">
                <Checkbox
                  color="info"
                  name="wakeupDetection"
                  onClick={event => wakeupCheckClick(event, i)}
                  checked={row.wakeupDetection == 1 ? true : false}
                  />
              </TableCell>
              {/* 
              <TableCell>
                <Checkbox
                  color="info"
                  name="fallDetection"
                  onClick={event => presenceCheckClick(event, i)}
                  checked={row.fallDetection == 1 ? true : false}
                  />
              </TableCell> */}
            </TableRow>
          ))}

        </TableBody>
      </Table>


      <Grid container style={{marginTop:10}}>
        <Grid item md={12} align="center">
          <Button
            style={{marginRight:30}}
            variant="contained" align="center" color="default" onClick={handleAddRow}>
           <FormattedMessage id="add_row" />
          </Button>

          <Button
            style={{marginRight:30}}
            variant="contained" align="center" color="default" onClick={handleRemoveBtn}>
           <FormattedMessage id="delete_selected_row" />
          </Button>

          <Button
            style={{marginRight:30}}
            variant="contained" align="center" color="primary" onClick={handleSaveBtn}>
           <FormattedMessage id="save" />
          </Button>
        </Grid>
      </Grid>

    </div>
    );
};


WakeUpSubRegion.propTypes = {
    className: PropTypes.string,
};

export default withRouter(WakeUpSubRegion);


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
}));